"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const modifierKeys = ["ctrlKey", "metaKey", "altKey", "shiftKey"];
const isModifiedClickEvent = (e) => modifierKeys.some((key) => key in e && e[key]);
exports.isModifiedClickEvent = isModifiedClickEvent;
//# sourceMappingURL=is-modified-click-event.js.map
